import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber diseño para usar el kit?',
    a: 'No, para nada. Las plantillas están listas para editar con Canva, que es gratis y súper fácil de usar. Solo cambiás el nombre, el color si querés, y listo.'
  }, {
    q: '¿Cómo recibo el kit después de comprar?',
    a: 'Al instante. En cuanto confirmás el pago te llega un email con el link de descarga. No tenés que esperar nada.'
  }, {
    q: '¿Cuántas veces puedo usar las plantillas?',
    a: 'Las veces que quieras. Es tuyo para siempre. Podés usarlo para fiestas propias o para clientes si tenés un emprendimiento.'
  }, {
    q: '¿Funciona en celular o solo en computadora?',
    a: 'Funciona en los dos. Canva tiene app para el celular y podés editar desde donde estés.'
  }, {
    q: '¿Puedo revender los diseños?',
    a: 'Podés usar los diseños para ofrecer servicios de decoración a clientes, sí. Lo que no podés es revender las plantillas en sí como producto propio.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 7 días de garantía total. Si no te convence, te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿En qué formato vienen las plantillas?',
    a: 'En links de Canva listos para editar, y también en PDF para imprimir directamente.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="pt-0 pb-16 px-4 bg-transparent" data-id="element-49">
      <div className="max-w-2xl mx-auto" data-id="element-50">
        <div className="text-center mb-8" data-id="element-51">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-dark mb-2 tracking-tight" data-id="element-52">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-53">
          {faqs.map((faq, i) => <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} key={i} className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-54">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center font-semibold text-sm text-dark hover:bg-primary/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-55">
                <span className="pr-4" data-id="element-56">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="shrink-0" data-id="element-57">
                  <ChevronDown className="w-5 h-5 text-primary" data-id="element-58" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-59">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-60">
                    <div className="px-5 pb-4 text-body/80 text-sm leading-relaxed" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}